import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import WaveSettingsSections from "@/components/waves/groups/WaveSettingsSections";
interface BrainRightSidebarSettingsProps {
  readonly wave: ApiWave;
}
export default function BrainRightSidebarSettings(t0) {
  const $ = _c(2);
  const {
    wave
  } = t0;
  let t1;
  if ($[0] !== wave) {
    t1 = <div className="tw-flex tw-flex-col tw-overflow-y-auto tw-bg-iron-950"><WaveSettingsSections wave={wave} /></div>;
    $[0] = wave;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}